<span class="info-tooltip-wrapper bff-text">
  <i class="fa fa-info-circle info-icon" (click)="toggleTooltip($event)"></i>
  <div class="info-tooltip-content" *ngIf="show">
    <button type="button" class="close-btn" (click)="hideTooltip($event)" aria-label="Fermer">&times;</button>
    <ng-container *ngIf="htmlTooltip; else defaultContent">
      <span [innerHTML]="htmlTooltip"></span>
    </ng-container>
    <ng-template #defaultContent>
      <span>Info</span>
    </ng-template>
  </div>
</span>